module.exports = __webpack_public_path__ + "img/buyHomeBanner2.c91f70e2.png";